import React, { useState } from 'react';
import styles from './CompanyInformations.module.sass';
import Card from '../../../components/Card';
import TextInput from '../../../components/TextInput';
import Dropdown from '../../../components/Dropdown';
import Switch from '../../../components/Switch';

// Options pour les partenaires
const SUBSCRIPTION_PLAN_OPTIONS = [
    { value: 'Basic', title: 'Basic' },
    { value: 'Premium', title: 'Premium' },
    { value: 'Enterprise', title: 'Enterprise' },
    { value: 'Custom', title: 'Custom' }
];

const PARTNER_TYPE_OPTIONS = [
    { value: 'Organisme de formation', title: 'Organisme de formation' },
    { value: 'Centre de formation', title: 'Centre de formation' },
    { value: 'École', title: 'École' },
    { value: 'Université', title: 'Université' },
    { value: 'Autre', title: 'Autre' }
];

const PartnerInformations = ({ partner, onPartnerChange, onDropdownChange, onSwitchChange }) => {
    return (
        <Card className={styles.card} title="Informations du partenaire" classTitle="title-green">
            <div className={styles.group}>
                <TextInput
                    className={styles.field}
                    label="Nom du partenaire"
                    name="name"
                    type="text"
                    placeholder="Nom du partenaire"
                    value={partner?.name || ''}
                    onChange={onPartnerChange}
                    required
                />
                <TextInput
                    className={styles.field}
                    label="Email du partenaire"
                    name="email"
                    type="email"
                    placeholder="email@example.com"
                    value={partner?.email || ''}
                    onChange={onPartnerChange}
                    required
                />
                <div className={styles.field}>
                    <Dropdown
                        className={styles.dropdown}
                        label="Plan d'abonnement :"
                        name="subscription_plan"
                        required
                        options={SUBSCRIPTION_PLAN_OPTIONS}
                        setValue={(option) => onDropdownChange('subscription_plan', option)}
                        value={SUBSCRIPTION_PLAN_OPTIONS.find(opt => opt.value === partner?.subscription_plan) || ''}
                    />
                </div>
                <div className={styles.field}>
                    <Dropdown
                        className={styles.dropdown}
                        label="Type de partenaire :"
                        name="partner_type"
                        options={PARTNER_TYPE_OPTIONS}
                        setValue={(option) => onDropdownChange('partner_type', option)}
                        value={PARTNER_TYPE_OPTIONS.find(opt => opt.value === partner?.partner_type) || ''}
                    />
                </div>
                <TextInput
                    className={styles.field}
                    label="Description"
                    name="description"
                    type="text"
                    placeholder="Description du partenaire"
                    value={partner?.description || ''}
                    onChange={onPartnerChange}
                />
                <TextInput
                    className={styles.field}
                    label="Site web"
                    name="website"
                    type="url"
                    placeholder="https://www.example.com"
                    value={partner?.website || ''}
                    onChange={onPartnerChange}
                />

                <div className={styles.field} style={{ display: 'flex', alignItems: 'center' }}>
                    <span style={{ marginLeft: '10px' }}>Compte démo :</span>
                    <Switch
                        name="demo_account"
                        value={partner?.demo_account || false}
                        onChange={(value) => onSwitchChange('demo_account', value)}
                        className={styles.switch}
                    />
                </div>

                <div className={styles.field} style={{ display: 'flex', alignItems: 'center' }}>
                    <span style={{ marginLeft: '10px' }}>Actif :</span>
                    <Switch
                        name="is_active"
                        value={partner?.is_active !== false} // Par défaut true
                        onChange={(value) => onSwitchChange('is_active', value)}
                        className={styles.switch}
                    />
                </div>

            </div>
        </Card>
    );
};

export default PartnerInformations;